const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment-timezone');

/**
 * Edit Workshops Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Workshops} Workshops injected to gain access to the Workshops resource
 */
app.controller('editWorkshop', ['Application', 'Authorization', 'Workshops', 'WorkshopInstances', 'UserWorkshops', 'MultiSessionWorkshops', 'Analyze', 'AccessHelper', 'SurveyHelper', '$scope', '$q', '$location', '$translate', function(Application, Authorization, Workshops, WorkshopInstances, UserWorkshops, MultiSessionWorkshops, Analyze, AccessHelper, SurveyHelper, $scope, $q, $location, $translate) {
    var self = this;
    self.isSession = Application.navigation.getPath().includes('multi-session-workshops');

    self.prevModalVisible = false;
    var routeParameters = Application.navigation.getRouteParameters();

    var newWorkshop;
    if (!self.isSession) {
      newWorkshop = routeParameters.id === 'new' || !routeParameters.id;
    } else {
      newWorkshop = !routeParameters.sessionid;
    }
    self.features = Application.features.flags();
    self.allowance = {
      create_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'workshops_create']], ['admin', 'creator', 'collaborator']),
      edit_workshop: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'workshops_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
      add_partner: self.features.enable_partners && !self.isSession && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!newWorkshop && !self.allowance.edit_workshop) || (newWorkshop && !self.allowance.create_workshop)) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.authtoken = Authorization.getAuthToken();
    self.user = Authorization.getAuthToken().user;
    self.company = Authorization.getAuthToken().company;
    self.msw = {};
    self.backButton = function () {
      if(self.isSession) {
        return `#/edit/multi-session-workshops/${routeParameters.id}`
      }
      return '#/overview/workshops'
    };

    self.workshopDynamic = self.company && self.company.workshops_dynamic_messaging;
    self.createFirstMessage = 'Please add at least one date or create this workshop prior to adding notifications.';

    self.emailTab = 'registration';
    self.preview = {
      'isActive': false,
      'body': '',
      'showButton': false,
      'isCentered': false
    };

    //injecting name, init on l:541
    self.translateData = {
      name: ''
    };
    self.onTitleChange = function(title) {
      self.translateData = {
        name: title
      };
    };

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (!self.info.newWorkshop) {
        // Allow the route change to progress
        self.info.denied = true;
        Application.messaging.clearMessages();
        return;
      }
      // Halt the route change and question the action
      self.info.path = {};
      self.info.path.targetPath = Application.navigation.getPath();
      self.info.path.targetSearch = Application.navigation.getUrlParameters();
      self.info.path.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.info.displayLeaveConfirm = true;
      self.info.usingCustomMessage = false;
      self.onLocationChange = function() {
        Application.messaging.clearMessages();
        if (self.info.newWorkshop && self.workshop && self.workshop._id) {
          self.comms.preCreateDelete(locationChange);
          return;
        }
        locationChange();
        if (self.info.newWorkshop) {
          $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
        }
      };
      self.onLocationChangeSave = function() {
        Application.messaging.clearMessages();
        if (self.info.newWorkshop && self.workshop && self.workshop._id) {
          locationChange();
          $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
          return;
        }

        self.info.loading = true;
        self.comms.creationRequest()
        .then(function(results) {
          self.info.loading = false;
          self.info.newWorkshop = false;
          self.info.denied = true;
          locationChange();
          $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
        }).catch(function(error) {
          self.info.loading = false;
          self.info.displayLeaveConfirm = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
          console.log('error creating draft: ', error);
        });
      };
    });

    self.info = {
      user: self.authtoken.user,
      newWorkshop: newWorkshop,
      timeAbbreviation: null,
      displayLeaveConfirm: false,
      denied: false,
      path: {},
      currentTab: 'details',
      states: [],
      addingDates: false,
      editingDate: false,
      hasDates: false,
      promptPublish: false,
      loading: false,
      workshopFields: 'title,company,published,description,related_workshops,image,banner_image,cover_justification,featured_justification,tags,archived,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private,linked_category,explore_hide,registration_disabled,auto_populate_disabled,notes,default_instance,supplemental_links,messaging_options,post_messaging_options,certificate,certificate_data,rating_configuration,allow_comments,type,surveys,partner_permissions,allow_reregistration,require_attendance_for_reregistration',
      workshopInstanceFields: 'workshop,start_date,end_date,group,online,location,host,related_workshops,online_location,online_location_label,site,google_calendar_entity,google_calendar_see_attendees,remove_on_google_decline',
      retakeableConfig: {
        checkRetakeOption: async () => {
          const registrations = await UserWorkshops.find({
            workshop: self.workshop._id,
            active_status: 'registered',
            fields: 'active_status'
          }).$promise;
          self.info.retakeableConfig.disableRetakeOption = self.workshop.allow_reregistration === true && registrations.length;
        },
        disableRetakeOption: false,
      },
      relatedChange: async function(items) {
        self.workshop.related_workshops = [];
        items.forEach(function(item) {
          if (!item._id) {
            return;
          }
          self.workshop.related_workshops.push(item._id);
        });
        await self.comms.blurSave('related_workshops');
      },
      goBack: function() {
        Application.navigation.goTo('overview/workshops');
      }
    };

    self.toggleAllowRetaking = async function() {
      self.workshop.allow_reregistration = !self.workshop.allow_reregistration;
      await self.comms.blurSave('allow_reregistration');
    }

    self.toggleAttendanceRequiredForRetaking = async function() {
      self.workshop.require_attendance_for_reregistration = !self.workshop.require_attendance_for_reregistration;
      await self.comms.blurSave('require_attendance_for_reregistration');
    }

    self.commentsChange = async function() {
      await self.comms.blurSave('allow_comments');
    };

    self.specialClose = function() {
      self.info.currentTab = self.specialCloseLast ? self.specialCloseLast : 'settings';
    };
    self.specialCloseLast = 'settings';

    self.info.timeAbbreviation = moment.tz(moment.tz.guess()).format('z');

    self.preEmail = {
      register_email_from: '',
      register_email_subject: '',
      register_email_body: '',
      parse: function() {
        if (!self.workshop.messaging_options || !self.workshop.messaging_options.length) {
          return;
        }
        self.workshop.messaging_options.forEach(function(item) {
          if (item.name === 'register_email_from') {
            self.preEmail['register_email_from'] = item.value;
          }
          if (item.name === 'register_email_subject') {
            self.preEmail['register_email_subject'] = item.value;
          }
          if (item.name === 'register_email_body') {
            function processValue(oldVal) {
              var newVal = oldVal.replace(/<(o)?(u)?l(\s)?>/g, '<$1$2l style="padding-left: 0; list-style-position: inside;">');
              return newVal;
            }
            ;
            var oldVal = item.value;
            self.preEmail['register_email_body'] = processValue(oldVal);
          }
        });
      },
      update: async function(type) {
        if (!self.workshop.messaging_options || !self.workshop.messaging_options.length) {
          self.workshop.messaging_options = [];
        }
        for (var i = 0; i < self.workshop.messaging_options.length; i++) {
          if (self.workshop.messaging_options[i].name === type) {
            self.workshop.messaging_options[i].value = self.preEmail[type];
            await self.comms.blurSave('messaging_options');
            return;
          }
        }
        self.workshop.messaging_options.push({name: type, value: self.preEmail[type]});
        await self.comms.blurSave('messaging_options');
      }
    };

    self.postEmail = {
      post_email_from: '',
      post_email_subject: '',
      post_email_body: '',
      parse: function() {
        if (!self.workshop.post_messaging_options || !self.workshop.post_messaging_options.length) {
          return;
        }
        self.workshop.post_messaging_options.forEach(function(item) {
          if (item.name === 'post_email_from') {
            self.postEmail['post_email_from'] = item.value;
          }
          if (item.name === 'post_email_subject') {
            self.postEmail['post_email_subject'] = item.value;
          }
          if (item.name === 'post_email_body') {
            self.postEmail['post_email_body'] = item.value;
          }
        });
      },
      update: async function(type) {
        if (!self.workshop.post_messaging_options || !self.workshop.post_messaging_options.length) {
          self.workshop.post_messaging_options = [];
        }
        for (var i = 0; i < self.workshop.post_messaging_options.length; i++) {
          if (self.workshop.post_messaging_options[i].name === type) {
            self.workshop.post_messaging_options[i].value = self.postEmail[type];
            await self.comms.blurSave('post_messaging_options');
            return;
          }
        }
        self.workshop.post_messaging_options.push({name: type, value: self.postEmail[type]});
        await self.comms.blurSave('post_messaging_options');
      }
    };

    self.comms = {
      loading: false,
      requiredFields: ['title'],
      blurSave: async function(field) {
        if (!self.workshop || !self.workshop._id || self.info.initializing) {
          if (field === 'image' && !self.workshop.banner_image) {
            self.workshop.banner_image = self.workshop.image;
          }
          return;
        }

        var previousState = self.info.states[self.info.states.length - 1];

        if (field !== 'collaborator' && field !== 'private' && field !== 'certificate' && self.workshop[field] === previousState[field]) {
          return;
        }

        if (field !== 'collaborator' && field !== 'certificate' && !self.workshop[field] && self.comms.requiredFields.indexOf(field) !== -1) {
          self.workshop[field] = previousState[field];
          return;
        }

        var body = {};
        if (field !== 'collaborator' && field !== 'certificate') {
          body[field] = self.workshop[field];
        }

        if (field === 'image') {
          body.banner_image = self.workshop.banner_image;
        }

        if (field === 'private') {
          body.privacy_departments = self.workshop.privacy_departments;
          body.privacy_locations = self.workshop.privacy_locations;
          body.privacy_teams = self.workshop.privacy_teams;
          body.privacy_grades = self.workshop.privacy_grades;
          body.privacy_org_levels = self.workshop.privacy_org_levels;
          body.privacy_groups = self.workshop.privacy_groups;
          body.privacy_collaborators = self.workshop.privacy_collaborators;
        }

        if (field === 'certificate') {
          body.certificate = self.workshop.certificate;
          body.certificate_data = self.workshop.certificate_data;
        }
        if (field === 'collaborator') {
          if (self.user.is_collaborator) {
            body.approval_required = true;
            body.approved = false;
          }
        }
        if (field === 'allow_reregistration') {
          if (!body[field]) {
            body.require_attendance_for_reregistration = false;
          }
          await self.info.retakeableConfig.checkRetakeOption();
        }
        self.comms.save(body).catch(function(error) {
          self.info.loading = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
            return;
          }
          Application.messaging.addMessage({type: 'error', text: 'Unable to save the workshop.', duration: 5});
        });
      },
      removeInstance: function() {
        if (!self.instances.instanceToRemove) {
          return;
        }
        self.info.loading = true;
        if (self.user.is_collaborator) {
          self.workshop.approval_required = true;
          self.workshop.approved = false;
        }
        WorkshopInstances.fullDelete({subresource: self.instances.instanceToRemove._id}).$promise
            .then(function(results) {
              self.comms.instanceRefresh().then(function() {
                self.instances.instanceToRemove = null;
                self.instances.showRemoval = false;
                Application.messaging.addMessage({type: 'success', duration: 4, text: 'The date was removed.'});
              });
              self.info.loading = false;
            }).catch(function(error) {
          console.log('error in instance removal: ', error);
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an error in removing this date.'});
          self.instances.instanceToRemove = null;
          self.instances.showRemoval = false;
          self.info.loading = false;
        });
      },
      confirmedRemoveGroup: function() {
        if (!self.instances.groupToRemove) {
          return;
        }
        self.info.loading = true;
        if (self.user.is_collaborator) {
          self.workshop.approval_required = true;
          self.workshop.approved = false;
        }
        WorkshopInstances.groupRemoval({subresource: self.workshop._id, subsubresource: self.instances.groupToRemove}).$promise
            .then(function(results) {
              self.comms.instanceRefresh().then(function() {
                self.instances.groupToRemove = null;
                self.instances.showGroupRemoval = false;
                Application.messaging.addMessage({type: 'success', duration: 4, text: 'The group dates were removed.'});
              });
              self.info.loading = false;
            }).catch(function(error) {
          console.log('error in instance removal: ', error);
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an error in removing this date group.'});
          self.instances.groupToRemove = null;
          self.instances.showGroupRemoval = false;
          self.info.loading = false;
        });
      },
      instanceRefresh: function() {
        var id = routeParameters.id || self.workshop._id;
        if (!id) {
          return;
        }
        if (self.isSession) {
          id =  self.workshop._id;
        }
        self.info.loading = true;
        return WorkshopInstances.find({
          workshop: id,
          fields: self.info.workshopInstanceFields,
          sort: 'start_date,1',
        }).$promise.then(function(data) {
          self.info.hasDates = false;
          self.info.addingDates = true;
          if (data && data.length) {
            self.info.hasDates = true;
            self.info.addingDates = false;
          }
          self.instances.setGroups(data);
          self.info.loading = false;
        }).catch(function(error) {
          self.info.loading = false;
        });
      },
      preCreateDelete: function(fn) {
        self.info.loading = true;
        if (!self.workshop || !self.workshop._id || !self.info.newWorkshop) {
          self.info.denied = true;
          fn();
          $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
        }

        Workshops.fullDelete({subresource: self.workshop._id}).$promise
            .then(function() {
              self.info.loading = false;
              self.info.denied = true;
              fn();
              $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
            }).catch(function() {
          self.info.loading = false;
          self.info.denied = true;
          fn();
          $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
        });
      },
      creationRequest: function() {
        if (self.isSession) {
          return MultiSessionWorkshops.createSession({subresource: routeParameters.id}, self.workshop).$promise;
        }
        return Workshops.create(self.workshop).$promise;
      },
      create: function(requested) {
        if (self.workshop && self.workshop._id) {
          self.info.newWorkshop = false;
          if (self.info.hasDates && self.workshop.image && self.workshop.banner_image) {
            self.info.promptPublish = true;
          }
          if (requested) {
            if (self.isSession) {
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations["edit.workshop.sessionCreated"]});
            } else {
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations["edit.workshop.workshopCreated"]});
            }
          }
          return;
        }

        self.info.loading = true;
        self.comms.creationRequest()
        .then(function(workshop) {
          if (self.isSession) {
            self.workshop._id = workshop.id;
            self.info.newWorkshop = false;
          } else {
            $location.path( '/edit/workshops/' + workshop._id);
            self.workshop = workshop;
          }
          self.info.states.push(JSON.parse(JSON.stringify(workshop)));
          if (requested) {
            if (self.isSession) {
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations["edit.workshop.sessionCreated"]});
            } else {
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations["edit.workshop.workshopCreated"]});
            }
            if (self.info.hasDates && self.workshop.image && self.workshop.banner_image) {
              self.info.promptPublish = true;
            }
          }
          self.info.loading = false;
        }).catch(function(error) {
          self.info.loading = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
          // handle error
          console.log('error creating workshop: ', error);
        });
      },
      save: function(body) {
        if (!body) {
          return;
        }
        self.info.loading = true;
        if (self.user.is_collaborator) {
          body.approval_required = true;
          body.approved = false;
        }
        return Workshops.update({subresource: self.workshop._id, fields: self.info.workshopFields}, body).$promise
        .then(function(data) {
          Analyze.record({resource: 'modifications'}, {document: self.workshop._id, type: 'workshop'});
          Application.analyticsProvider.trackEvent('workshop_updated', {content: self.workshop._id, type: 'workshop', title: self.workshop.title});
          self.info.states.push(JSON.parse(JSON.stringify(data)));
          // This is a temporary fix for an issue with the add-edit-images directive going blank from replacing content with a new object while active
          if (body.featured_justification || body.cover_justification || body.image || body.banner_image || body.rating_configuration) {
            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Changes saved.'});
            self.info.loading = false;
            return;
          }
          self.workshop = data;
          self.preEmail.parse();
          self.postEmail.parse();
          self.info.loading = false;
          if (self.info.newWorkshop) {
            return;
          }
          Application.messaging.addMessage({type: 'success', duration: 3, text: 'Changes saved.'});
        });
      },
      publish: function() {
        if (!self.info.hasDates) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add dates before publishing.'});
          return;
        }
        if (!self.workshop.image || !self.workshop.banner_image) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add images before publishing.'});
          return;
        }
        this.save({published: true})
        .then(function() {
          self.info.promptPublish = false;
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'The workshop ' + self.workshop.title + ' was published.'});
          if (self.isSession) {
            Application.trackState.set({startTab: 'sessions'});
            Application.navigation.goTo('/edit/multi-session-workshops/' + routeParameters.id);
          }
        }).catch(function(error) {
          self.info.loading = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
            return;
          }
          Application.messaging.addMessage({type: 'error', text: 'Unable to save the workshop.', duration: 5});
        });
      },
      archive: function() {
        // Hook up archiving

        // self.comms.loading = true;
        // Viewables.archive({content: [{id: self.workshop._id, type: 'workshop'}]}).$promise
        // .then(function(results) {
        //   Application.messaging.addMessage({type: 'success', text: 'The workshop was archived.', duration: 5});
        //   Analyze.record({resource: 'deletions'}, {document: self.workshop._id, type: 'workshop'});
        //   Application.navigation.goTo('/overview/content');
        //   self.comms.loading = false;
        //   self.info.showArchive = false;
        // }).catch(function(err) {
        //   self.comms.loading = false;
        //   self.info.showArchive = false;
        //   Application.messaging.addMessage({type: 'error', text: 'There was an issue removing this article. Please try again later or contact Continu from the help button.', duration: 5});
        // });
      }
    };

    self.workshop = {
      user: self.info.user._id,
      title: '',
      tags: '',
      //privacy_collaborators: [],
      privacy_locations: [],
      privacy_departments: [],
      privacy_teams: [],
      privacy_org_level: [],
      privacy_grade: [],
      linked_category: [],
      supplemental_links: [],
      notes: '',
      messaging_options: [],
      post_messaging_options: []
    };
    self.showCollaborators = false;

    self.navigation = {
      directory: {
        'details': {
          next: 'dates',
          previous: null,
          required: function() {
            var missing = [];
            if (!self.workshop.title) {
              missing.push('title');
            }
            if (!self.workshop.description) {
              missing.push('description');
            }
            if (missing.length) {
              return missing;
            }
            return null;
          }
        },
        'dates': {
          next: 'images',
          previous: 'details',
          required: null
        },
        'images': {
          next: self.isSession ? 'settings' : 'categories',
          previous: 'dates',
          required: null
        },
        'categories': {
          next: 'settings',
          previous: 'images',
          required: null
        },
        'settings': {
          next: 'preview',
          previous: self.isSession ? 'images' : 'categories',
          required: null
        },
        'preview': {
          next: null,
          previous: 'settings',
          required: null
        },
      },
      next: function(option) {
        if (self.isSession && !option && this.directory[self.info.currentTab].next === 'preview') {
          self.previewModalVisible = true;
          return;
        }
        option = option || this.directory[self.info.currentTab].next;
        if (!option || !this.directory[option]) {
          return;
        }
        if ((!self.instances.list || !self.instances.list.length) && this.directory[option].previous === 'settings') {
          Application.messaging.addMessage({type: 'error', duration: 4, text: 'Preview is not available without any created dates.'});
          return;
        }
        
        for (var key in this.directory) {
          if (option === key) {
            self.info.currentTab = option;
            if (option !== 'preview') {
              self.specialCloseLast = option;
            }
            setTimeout(function() {
              window.scrollTo(0, 0);
            }, 5);
            return;
          }
          if (this.directory[key].required) {
            var missing = this.directory[key].required();
          }
          if (missing && missing.length) {
            var message = 'The following fields are required: ';
            missing.forEach(function(item, index) {
              message += item;
              if (index === (missing.length - 1)) {
                message += '.';
                return;
              }
              message += ', ';
            });
            Application.messaging.addMessage({type: 'error', duration: 6, text: message});
            return;
          }
        }
      },
      previous: function(option) {
        option = option || this.directory[self.info.currentTab].previous;
        if (!option || !this.directory[option]) {
          return;
        }
        self.info.currentTab = option;
      }
    };

    self.instances = {
      list: [],
      defaultInstance: null,
      activeEdit: null,
      groups: [],
      activeIndex: {},
      showRemoval: false,
      showGroupRemoval: false,
      instanceToRemove: null,
      groupToRemove: null,
      clone: function(instance) {
        if (!instance || !instance._id) {
          return;
        }
        self.instances.defaultInstance = instance._id;
        self.info.addingDates = true;
      },
      listDate: function(day) {
        return moment(new Date(day)).tz(moment.tz.guess()).format('dddd, MMMM D, YYYY (h:mma z)');
      },
      getHost: function(instance) {
        return instance && instance.host && instance.host.name ? '- ' + instance.host.name : '';
      },
      setGroups: function(items) {
        this.list = items;
        var groupBlock = {};
        this.defaultInstance = null;
        this.groups = [];
        items.forEach(function(item) {
          if (!item.group) {
            return;
          }
          if (!self.instances.defaultInstance) {
            self.instances.defaultInstance = item._id;
          }
          if (!groupBlock[item.group]) {
            groupBlock[item.group] = [];
          }
          if (new Date().valueOf() > new Date(item.end_date).valueOf()) {
            item.ended = true;
          }
          groupBlock[item.group].push(item);
        });
        for (var key in groupBlock) {
          if (groupBlock[key].length) {
            groupBlock[key].sort(function(a, b) {
              if (!a.start_date || !b.start_date) {
                return -1;
              }
              return new Date(a.start_date).valueOf() - new Date(b.start_date).valueOf();
            });
          }
          this.groups.push(groupBlock[key]);
        }
      },
      remove: function(instance, confirm) {
        if (!confirm && (!instance || !instance._id)) {
          return;
        }
        if (confirm) {
          self.comms.removeInstance();
          return;
        }
        self.instances.instanceToRemove = instance;

        // Only allow if time has not passed
        // Notify admin that records will be deleted, and regstered users will be notified of canceled date
        // Allow admin to confirm
        if (instance.ended) {
          Application.messaging.addMessage({type: 'info', duration: 5, text: 'This date has passed and can no longer be removed'});
          return;
        }
        self.instances.showRemoval = true;
      },
      removeGroup: function(group, confirm) {
        var groupNumber = group && group[0] && group[0].group;
        if (!confirm && !groupNumber) {
          return;
        }
        if (confirm) {
          self.comms.confirmedRemoveGroup();
          return;
        }
        self.instances.groupToRemove = groupNumber;
        self.instances.showGroupRemoval = true;
      },
      editInstance: function(instance) {
        if (!instance || !instance._id) {
          return;
        }
        self.instances.activeEdit = instance;
        self.info.editingDate = true;
      },
      instanceExit: function() {
        self.info.editingDate = false;
        self.info.addingDates = false;
        self.comms.instanceRefresh();
      }
    };

    self.sessionMessaging = function(isNewWorkshop) {
      MultiSessionWorkshops.findOne({subresource: routeParameters.id}).$promise.then(function(msw) {
        self.msw = msw;
        if (self.msw && self.msw.name) {
          var stateMessage = isNewWorkshop ? 'edit.multi_session_workshop.add_session' : 'edit.multi_session_workshop.edit_session';
          $translate(stateMessage, {title: self.msw.name})
            .then(function(result) {
              Application.messaging.addMessage({type: 'insidetrack', text: result, trackstate: true, link: '/edit/multi-session-workshops/' + routeParameters.id});
            });
        }
      })
    }

    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.workshop.surveys;
        self.surveyAssociation.surveyIds.push(self.workshop.surveys[0].survey_id);
      }
    };

    self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }
      // populate default_instance if found
      self.info.initializing = true;
      if (self.info.newWorkshop) {
        self.workshop.privacy_collaborators = [];
        if (self.user.is_collaborator) {
          self.workshop.privacy_collaborators.push(self.user._id);
          self.workshop.approval_required = true;
          self.workshop.approved = false;
        }
        self.info.addingDates = true;
        self.info.states.push(JSON.parse(JSON.stringify(self.workshop)));
        if (self.isSession) {
          self.sessionMessaging(true);
        }
        self.info.initializing = false;
        return;
      }
      $q.all([
        Workshops.get({
          subresource: self.isSession ? routeParameters.sessionid : routeParameters.id,
          fields: self.info.workshopFields
        }).$promise,
        WorkshopInstances.find({
          workshop: self.isSession ? routeParameters.sessionid : routeParameters.id,
          fields: self.info.workshopInstanceFields,
          sort: 'start_date,1',
        }).$promise
      ]).then(async function(data) {
        if ((data[0].company !== self.authtoken.company._id) || (data[0].privacy_collaborators && self.user.is_collaborator && data[0].privacy_collaborators.length && data[0].privacy_collaborators.indexOf(self.user._id) === -1) || (self.user.is_collaborator && self.msw && self.msw.collaborators && self.msw.collaborators.length && self.msw.collaborators.indexOf(self.user._id) === -1)) {
          self.editSaved = true;
          Application.navigation.goToHome();
          return;
        }
        self.workshop = data[0];
        if (!self.workshop.privacy_collaborators) {
          self.workshop.privacy_collaborators = [];
        }
        if (self.workshop.privacy_collaborators.length && !self.user.is_collaborator) {
          self.showCollaborators = true;
        }
        self.preEmail.parse();
        self.postEmail.parse();
        self.info.states.push(JSON.parse(JSON.stringify(data[0])));
        self.instances.setGroups(data[1]);
        self.info.hasDates = true;
        if (!data[1] || !data[1].length) {
          self.info.addingDates = true;
          self.info.hasDates = false;
        }
        if (self.isSession) {
          self.sessionMessaging(false);
        }
        self.onTitleChange(self.workshop.title);
        if (self.workshop.surveys.length) {
          self.surveyAssociation.initSurveyData();
        }
        if (self.workshop.partner_permissions) {
          self.partners.partnerPermission = self.workshop.partner_permissions;
        }
        await self.info.retakeableConfig.checkRetakeOption();
        self.startEditWatch();
        setTimeout(function() {
          self.info.initializing = false;
        }, 1000);
      }).catch(function(error) {
        console.log('error: ', error);
      });
    };

    self.startEditWatch = function() {
      $scope.$watch('editor.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);

      $scope.$watch('editor.surveyAssociation.surveyIds', async function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.workshop.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
        await self.comms.blurSave('surveys');
      }, true);
      $scope.$watch('editor.partners.partnerPermission', async function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.workshop.partner_permissions = newVal;
        await self.comms.blurSave('partner_permissions');
      }, true);
    }

    $translate([
      "edit.workshop.sessionCreated",
      "edit.workshop.workshopCreated"
    ]).then(function(translations){
      self.translations = translations;
    });

    self.initialize();

  }]);
